import { BrokerProfileType } from "@/src/type";
import { http } from "./FlowFrontendService";

async function getProfile() {
  return await http<BrokerProfileType.BrokerProfileResponse>("GET", "/v1/broker/profile");
}

async function saveProfile(profile: BrokerProfileType.BrokerProfile) {
  return await http<BrokerProfileType.BrokerProfileResponse>("POST", "/v1/broker/profile", undefined, profile);
}

async function updateProfile(profile: BrokerProfileType.BrokerProfile) {
  return await http<BrokerProfileType.BrokerProfileResponse>("PUT", "/v1/broker/profile", undefined, profile);
}

//Update without checking if the profile exists
async function quickUpdateProfile(profile: BrokerProfileType.BrokerProfile) {
  return await http<BrokerProfileType.BrokerProfileResponse>("PATCH", "/v1/broker/profile", undefined, profile);
}

// done for launch event, may need to remove after
async function approveProfile() {
  return await http<BrokerProfileType.BrokerProfileResponse>("PUT", "/v1/broker/profile/auto-approval");
}

export default {
  saveProfile,
  getProfile,
  updateProfile,
  quickUpdateProfile,
  approveProfile,
};
